import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { generatePath, Link, useNavigate, useParams } from 'react-router-dom';
import { EyeOutlined, GlobalOutlined, UserOutlined } from '@ant-design/icons';
// import styles from './index.module.scss';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import ImageCol from '@components/common/table/ImageCol';
import {
    AppConstants,
    categoryKind,
    DEFAULT_FORMAT,
    DEFAULT_TABLE_ITEM_SIZE,
    DEFAULT_TABLE_ITEM_SIZE_LARGE,
} from '@constants';
import apiConfig from '@constants/apiConfig';
import { FieldTypes } from '@constants/formConfig';
import { statusOptions } from '@constants/masterData';
import useFetch from '@hooks/useFetch';
import useListBase from '@hooks/useListBase';
import useNotification from '@hooks/useNotification';
import useTranslate from '@hooks/useTranslate';
import { AvatarField, BaseTable,BaseTooltip } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { convertUtcToLocalTime } from '@utils';
import { Button, Modal, Tag } from 'antd';

import routes from '../routes';

import '../../../styles/_common.scss';

const message = defineMessages({
    objectName: 'INWENS',
});

const InwenChildListPage = () => {
    const translate = useTranslate();
    const navigate = useNavigate();
    const notification = useNotification();
    const statusValues = translate.formatKeys(statusOptions, [ 'label' ]);
    const [ showPreviewModal, setShowPreviewModal ] = useState(false);
    const params = new URLSearchParams(location.search);
    const parentId = params.get('parentId');
    const name = params.get('name');
    const page = params.get('page');

    const { data, mixinFuncs, queryFilter, loading, pagination, serializeParams } = useListBase({
        apiConfig: apiConfig.inwen,
        options: {
            pageSize: DEFAULT_TABLE_ITEM_SIZE_LARGE,
            objectName: translate.formatMessage(message.objectName),
        },
        params: {
            page: page,
            parentId: parentId,
        },
        override: (funcs) => {
            funcs.mappingData = (response) => {
                if (response.result === true) {
                    return {
                        data: response.data.content,
                        total: response.data.totalElements,
                    };
                }
            };
            // funcs.getList = () => {
            //     mixinFuncs.handleFetchList({
            //         page: page,
            //         parentId: parentId,
            //     });
            // };
            funcs.getList = () => {
                const params = {
                    page: pagination.current - 1,
                    size: pagination.pageSize,
                    parentId: parentId,
                    ...queryFilter,
                };
                return mixinFuncs.handleFetchList(params);
            };
            funcs.getItemDetailLink = (dataRow) => {
                const currentPath = location.pathname;
                const searchParams = location.search;
                return `${currentPath}/${dataRow.id}${searchParams}`;
            };

            funcs.getCreateLink = () => {
                const currentPath = location.pathname;
                const searchParams = location.search;
                return `${currentPath}/create${searchParams}`;
            };
            funcs.changeFilter = (filter) => {
                const params = {
                    parentId,
                    name,
                    ...filter,
                };
                const filteredParams = Object.fromEntries(Object.entries(params).filter(([ _, value ]) => value != null));
                mixinFuncs.setQueryParams(serializeParams(filteredParams));
            };
        },
    });

    const columns = [
        {
            title: 'Image',
            dataIndex: 'inwenMediaLibraryData',
            render: (value) => (
                <ImageCol
                    style={{ backgroundColor: '#232935', objectFit: 'contain' }}
                    path={value ? `data:image/jpeg;base64,${value}` : null}
                    className="img-inwen"
                />
            ),
            width: '150px',
        },
        {
            title: <FormattedMessage defaultMessage="Name" />,
            dataIndex: 'inwenMediaLibraryName',
            // render: (name, datarow) => {
            //     return (
            //         <>
            //             {datarow.hasChild ? (
            //                 <Link to={generatePath(sitePathConfig.inwenManagementChildPage.path, { id: datarow.id })}>
            //                     {name}
            //                 </Link>
            //             ) : (
            //                 <span>{name}</span>
            //             )}
            //         </>
            //     );
            // },
        },
        mixinFuncs.renderActionColumn(
            {
                edit: true,
                delete: true,
            },
            { width: '120px' },
        ),
    ];

    const searchFields = [
        {
            key: 'inwenMediaLibraryName',
            placeholder: translate.formatMessage(commonMessage.Name),
        },
    ];

    return (
        <PageWrapper
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.MediaLibrary),
                    //path: `${generatePath(routes.inwenChildListPage.path, { id: parentId })}?parentId=${parentId}`,
                    path: generatePath(routes.inwenListPage.path),
                },
                { breadcrumbName: name },
            ]}
        >
            <ListPage
                searchForm={mixinFuncs.renderSearchForm({ fields: searchFields, initialValues: queryFilter })}
                actionBar={mixinFuncs.renderActionBar()}
                baseTable={
                    <BaseTable
                        onChange={mixinFuncs.changePagination}
                        columns={columns}
                        dataSource={data}
                        // loading={loading || getCategoriesLoading || updateNewsPinLoading}
                        pagination={pagination}
                    />
                }
            />
            <Modal
                title={<FormattedMessage defaultMessage="Preview" />}
                width={1000}
                open={showPreviewModal}
                footer={null}
                centered
                onCancel={() => setShowPreviewModal(false)}
            >
                {/* {newsContent && (
                    <div className={styles.previewContent} dangerouslySetInnerHTML={{ __html: newsContent }}></div>
                )} */}
            </Modal>
        </PageWrapper>
    );
};

export default InwenChildListPage;
